/*
 * BONSAI: メガドロップダウンをマウスを乗せただけで開く（旧サイトと同じ操作感・No.630）。
 * クリック・キーボードでの開閉は Rise 標準（details/summary と header-menu）のまま。
 * タッチ端末（hover が無い端末）では何もしない。
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const OPEN_DELAY = 80;   // 横切っただけで開かないように
  const CLOSE_DELAY = 200; // メニュー名からパネルへ移る間に閉じないように

  document.querySelectorAll('details[data-bm-hover]').forEach((details) => {
    const host = details.closest('header-menu') || details;
    const summary = details.querySelector('summary');
    let timer;

    const setOpen = (open) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (open === details.open) return;
        if (open) {
          // 他に開いているメニューは閉じる
          document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => {
            if (d !== details) {
              d.removeAttribute('open');
              d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          });
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
        summary.setAttribute('aria-expanded', String(open));
      }, open ? OPEN_DELAY : CLOSE_DELAY);
    };

    host.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && setOpen(true));
    host.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && setOpen(false));

    // パネル内のリンクへ移動したら閉じる（ページ遷移中に開いたまま残さない）
    details.addEventListener('click', (e) => {
      if (e.target.closest('a')) setOpen(false);
    });
  });
})();

/*
 * BONSAI: 目的別の2ペイン型（No.644・No.646）。
 * 左の見出し（ボタン）を押す、キーボードで移る、またはマウスを0.15秒乗せると右の中身を切り替える。
 * 見出しを押してもページは移動しない（棚へは右上の「すべて見る」から）。
 */
(function () {
  const HOVER_DELAY = 150; // 右のカードへ斜めに移る途中で別の見出しを横切っても切り替わらない程度
  document.querySelectorAll('[data-bm-split]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-bm-tab]');
    const panes = root.querySelectorAll('[data-bm-pane]');
    let timer;
    const show = (key) => {
      clearTimeout(timer);
      tabs.forEach((t) => {
        const on = t.dataset.bmTab === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-expanded', String(on));
      });
      panes.forEach((p) => p.classList.toggle('is-active', p.dataset.bmPane === key));
    };
    // どの見出しから棚へ移動したかを覚えておき、移動先のページで同じ見出しを選んだ状態にする（No.647）。
    // 同じ棚が複数の見出しにある（キャリア＝外装とツーリング等）ため、URLだけでは決められない。
    // 保存はこのタブの間だけ（sessionStorage）。使えない環境では Liquid 側の判定のまま。
    const KEY = 'bm-split:' + root.dataset.bmSplit;
    try {
      const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (saved && saved.path === location.pathname && root.querySelector(`[data-bm-tab="${saved.tab}"]`)) show(saved.tab);
    } catch (e) {}
    root.querySelectorAll('[data-bm-pane]').forEach((pane) => {
      pane.addEventListener('click', (e) => {
        const a = e.target.closest('a[href]');
        if (!a) return;
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ tab: pane.dataset.bmPane, path: new URL(a.href, location.href).pathname }));
        } catch (err) {}
      });
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => show(tab.dataset.bmTab));
      tab.addEventListener('focus', () => show(tab.dataset.bmTab));
      tab.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => show(tab.dataset.bmTab), HOVER_DELAY);
      });
      tab.addEventListener('pointerleave', () => clearTimeout(timer));
    });
  });
})();

/*
 * BONSAI: メガドロップダウンを開いている間、本文を暗くする覆い（No.652）。
 * details.bm-mega の開閉（クリック・ホバー・キーボードのどれでも）に追従する。覆いを押すとメニューを閉じる。
 */
(function () {
  const megas = document.querySelectorAll('details.bm-mega');
  if (!megas.length) return;
  const backdrop = document.createElement('div');
  backdrop.className = 'bm-mega-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  document.body.appendChild(backdrop);

  const sync = () => {
    const anyOpen = [...megas].some((d) => d.open);
    backdrop.classList.toggle('is-visible', anyOpen);
  };
  megas.forEach((d) => d.addEventListener('toggle', sync));
  backdrop.addEventListener('click', () => {
    megas.forEach((d) => {
      if (!d.open) return;
      d.removeAttribute('open');
      d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    sync();
  });
})();
